import { render, staticRenderFns } from "./DocumentManagement.vue?vue&type=template&id=75bbe4f1&scoped=true&"
import script from "./DocumentManagement.vue?vue&type=script&lang=js&"
export * from "./DocumentManagement.vue?vue&type=script&lang=js&"
import style0 from "./DocumentManagement.vue?vue&type=style&index=0&id=75bbe4f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bbe4f1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75bbe4f1')) {
      api.createRecord('75bbe4f1', component.options)
    } else {
      api.reload('75bbe4f1', component.options)
    }
    module.hot.accept("./DocumentManagement.vue?vue&type=template&id=75bbe4f1&scoped=true&", function () {
      api.rerender('75bbe4f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/vistas/DocumentManagement.vue"
export default component.exports